import React, { useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

import CommentsList from '~/Share/containers/CommentList';
import type { Reply } from '~/types/models/reply';
import type { UserSimple } from '~/types/models';

const CommentListContainer = styled.div<
  Pick<NextGenCommentListProps, 'showCommentList' | 'expand'>
>`
  height: 100%;
  padding: 27px;
  display: flex;
  flex-direction: column;
  font-family: 'Lato', sans-serif;
  font-size: 1.2em;
  padding-bottom: 10px;
  overflow-y: auto;
  background-color: white;

  @media (max-width: 850px) {
    height: ${(props) => (props.expand ? '100%' : '300px')};
    display: ${(props) => (props.showCommentList ? 'flex' : 'none')};
  }
`;

export type NextGenCommentListProps = {
  comments: Reply[];
  assignee: Pick<UserSimple, 'first_name'>;
  showCommentList: boolean;
  className?: string;
  expand?: boolean;
};

export default function NextGenCommentList({
  comments,
  assignee,
  showCommentList,
  className,
  expand = false,
}: NextGenCommentListProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollRef || !scrollRef.current) return;

    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [scrollRef, comments]);

  return (
    <CommentListContainer
      className={cx('comment-list', className)}
      ref={scrollRef}
      showCommentList={showCommentList}
      expand={expand}
    >
      {showCommentList && (
        <CommentsList
          comments={comments}
          recipientName={assignee.first_name ?? ''}
          viewedByRecipient
        />
      )}
    </CommentListContainer>
  );
}
